import React from "react";

const Guide = ()=> {

  return (
    <div className="p-4">
      <h5> How it works? </h5>
      <ul>
        <li>Download our casual games and try to <strong>break the record.</strong> Every day a new record will be set. </li>
        <li className="m-t-20"><strong>IMPORTANT</strong> <br/> You need to copy the ID from the game and paste it into the ED Token field and save it so the score will be sent. </li>
      </ul>

      <hr/>

      <h5>How to win points? </h5>
      <ul>
        <li>Play and make a highscore. Check this page to see the current record and your progress.</li>
        <li>The record will be available once a day.</li>
      </ul>
    </div>
  );
};

export default Guide;
